<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Home',
            path: '/Home',
            icon: '',
          }"
          
        >
        </sidebar-item>

        <sidebar-item
            :link="{
              name: 'Venue',
              path: '/Venue',
              icon: ''
              }"
            >
        </sidebar-item>

        <sidebar-item
              :link="{
                name: 'Key Dates',
                path: '/KeyDates',
                icon: ''
              }">
        </sidebar-item>

        <sidebar-item
              :link="{
                name: 'Call for Papers',
                path: '/CallForPapers',
                icon: ''
                }">
        </sidebar-item>

        <sidebar-item
                :link="{
                  name: 'Paper Submission',
                  path: '/PaperSubmission',
                  icon: ''
                }">
        </sidebar-item>

        <sidebar-item
                  :link="{
                    name: 'Committees',
                    path: '/Committees',
                    icon: ''
                  }">
        </sidebar-item>
        <sidebar-item
                  :link="{
                    name: 'Registration',
                    path: '/Registration',
                    icon: ''
                  }">
        </sidebar-item>
        <sidebar-item
                  :link="{
                    name: 'Program',
                    path: '/Program',
                    icon: ''
                  }">
        </sidebar-item>
        <sidebar-item
                  :link="{
                    name: 'AboutIDASB',
                    path: '/AboutIDASB',
                    icon: ''
                  }">
        </sidebar-item>
        <sidebar-item
                  :link="{
                    name: 'Contact',
                    path: '/Contact',
                    icon: ''
                  }">
        </sidebar-item>



      </template>

      <template slot="links-after">
        <hr class="my-3">
        <!-- <h6 class="navbar-heading p-0 text-muted">Documentation</h6> -->

        <!-- <b-nav class="navbar-nav mb-md-3"> -->
          <!-- <b-nav-item
               href="https://www.creative-tim.com/learning-lab/bootstrap-vue/quick-start/argon-dashboard"
               >
              <i class="ni ni-spaceship"></i>
              <b-nav-text class="p-0">Getting started</b-nav-text>
          </b-nav-item> -->
          <!-- <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/colors/argon-dashboard">
              <i class="ni ni-palette"></i>
              <b-nav-text class="p-0">Foundation</b-nav-text>
          </b-nav-item> -->
          <!-- <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/avatar/argon-dashboard">
              <i class="ni ni-ui-04"></i>
              <b-nav-text class="p-0">Components</b-nav-text>
          </b-nav-item> -->
        <!-- </b-nav> -->
      </template>
    </side-bar>
    <div class="main-content">
      <!-- <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar> -->

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <!-- <content-footer v-if="!$route.meta.hideFooter"></content-footer> -->
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import DashboardContent from './Content.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      DashboardContent,
      FadeTransition
    },
    methods: {
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      }
    },
    mounted() {
      this.initScrollbar()
    }
  };
</script>
<style lang="scss">
</style>
